import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Product} from '../models/product';
import {LoadProductsSuccessAction, productsActionTypes} from '../actions/product';
import { productsCompleteListActionTypes} from '../actions/product-complete-list';

export interface ProductsState {
  array: Product[];
}

const initialState: ProductsState = {
  array: []
};

export function productsReducer(state: ProductsState = initialState, action: Action): ProductsState {
  switch (action.type) {
    case productsActionTypes.LOAD_SUCCESS:
    case productsCompleteListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case productsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case productsCompleteListActionTypes.CLEAR:
      return handleLoadClearAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ProductsState, action: LoadProductsSuccessAction): ProductsState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}



function handleLoadFailAction(state: ProductsState): ProductsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}
function handleLoadClearAction(state: ProductsState): ProductsState {
  return initialState;
}

export const productsSelectors = {
  array: (state: ProductsState) => _.get(state, 'array', [])
};
